import { useCallback, useEffect, useRef } from 'react';
import Glide from '@glidejs/glide';
import '@glidejs/glide/dist/css/glide.core.min.css';
import '@glidejs/glide/dist/css/glide.theme.min.css';
import { func, node, shape } from 'prop-types';
import superDestacadoConfig from './config';
import { childrenPropType } from '../../../../../utils';

const WidgetSuperdestacado = ({ children, config, onSlideClick, widget }) => {
  const glideRef = useRef();

  const handleClick = useCallback(
    e => {
      if (onSlideClick) {
        onSlideClick(e);
      } else {
        const li = e.target.closest('li');
        if (li && !li.classList.contains('glide__slide--active')) {
          const { index } = li.dataset;
          if (index !== undefined) {
            e.preventDefault();
            e.stopPropagation();
            const gap = 1;
            const diff = Math.abs(glideRef.current.index - index);

            // Si la diferencia es mayor al gap debemos ver hacia que lado ir, porque si es infinito puede que vaya al principio si seleccionamos el siguiente y estamos al final
            if (diff > gap) {
              glideRef.current.go(
                `${Number(index) > glideRef.current.index ? '<' : '>'}`
              );
            } else {
              glideRef.current.go(`=${index}`);
            }
          }
        }
      }
    },
    [onSlideClick]
  );

  useEffect(() => {
    try {
      const container = widget.querySelector('.glide');
      if (container) {
        const currentConfig = { ...config };

        // Comprobamos si tenemos que ajustar el perView porque hay pocos elementos
        const numItems = container.querySelectorAll('.glide__slide').length;
        const breakpoints = Object.keys(config.breakpoints).sort(
          (a, b) => Number(a) - Number(b)
        );
        const activeBreakpoint = breakpoints.find(k => window.innerWidth <= k);

        const perView =
          config.breakpoints[activeBreakpoint].perView || config.perView;

        if (numItems < perView) {
          currentConfig.breakpoints[activeBreakpoint].perView = numItems;
        }

        const glide = new Glide(container, currentConfig);
        glide.mount();

        glideRef.current = glide;
        const slides = container.querySelectorAll('.glide__slide a');
        if (slides) {
          slides.forEach(slide => slide.addEventListener('click', handleClick));
        }
      }

      return () => {
        if (glideRef.current) {
          const slides = container.querySelectorAll('.glide__slide a');
          if (slides) {
            slides.forEach(slide =>
              slide.removeEventListener('click', handleClick)
            );
          }
          glideRef.current.destroy();
        }
      };
    } catch (err) {
      console.log(`Ha ocurrido un error al montar el super destacado `);
    }
    return () => null;
  }, [config, handleClick, widget]);

  return children;
};

WidgetSuperdestacado.propTypes = {
  widget: node.isRequired,
  config: shape({}),
  children: childrenPropType,
  onSlideClick: func
};

WidgetSuperdestacado.defaultProps = {
  onSlideClick: null,
  children: null,
  config: superDestacadoConfig
};

export default WidgetSuperdestacado;
